import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

let allActionCreators = Object.assign({});

class Dashboard extends React.Component {

  hardNav() {
    window.location.href = '/diamonds';
  }

	render() {
		return <div className='Dashboard' onClick={this.hardNav.bind(this)}></div>;
	}
}
export default Dashboard;

function mapStateToProps(state) {
  return {

  };
}

export const DashboardContainer = connect(
  mapStateToProps,
  allActionCreators
)(Dashboard);